export default __webpack_public_path__ + "static/media/correct18.b2a7fb96.mp3";